import { render, staticRenderFns } from "./LojasLista.vue?vue&type=template&id=468589bb&scoped=true&"
import script from "./LojasLista.vue?vue&type=script&lang=js&"
export * from "./LojasLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468589bb",
  null
  
)

export default component.exports